<odx-form-field [formGroup]="formGroup" [label]="label" [readonly]="disabled">
  <odx-select
    odxFormFieldControl
    [formControlName]="controlName"
    i18n-placeholder="@@selectCountry.placeholder"
    placeholder="Land auswählen"
  >
    @for (country of localizedCountryNames | odxAutocompleteSearchFilter; track $index) {
      <odx-select-option [value]="country" (click)="onSelect(country)">
        <odx-highlight [odxHighlightSearch]="searchInput.value" [text]="country">
          {{ country }}
        </odx-highlight>
      </odx-select-option>
    }
    <input
      #searchInput
      i18n-placeholder="@@selectCountry.placeholder"
      placeholder="Land auswählen"
      [odxSelectSearchField]="noCountryFoundMessage"
    />
  </odx-select>
</odx-form-field>
